/** @jsxImportSource react */
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import appRoutes from './App'
import { store } from './store'
import ColorModeProvider from './theme/ColorModeProvider'
import NotificationProvider from './components/common/NotificationProvider'
import './index.css'
import { registerServiceWorker } from './pwa'

registerServiceWorker()

const router = createBrowserRouter(createRoutesFromElements(appRoutes), {
  future: { v7_relativeSplatPath: true, v7_fetcherPersist: true, v7_normalizeFormMethod: true, v7_partialHydration: true, v7_skipActionErrorRevalidation: true },
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // 4xx won't fix itself on retry
      retry: (count, error) => count < 2 && !(error?.response?.status >= 400 && error?.response?.status < 500),
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ColorModeProvider>
          <NotificationProvider>
            <RouterProvider router={router} future={{ v7_startTransition: true }} />
          </NotificationProvider>
        </ColorModeProvider>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
)
